import { apiRequest } from '../../../../shared/api/index.js';

export const unlinkPaymentMerchant = async (linkId: string): Promise<void> => {
  await apiRequest<void>(`/bank/payment-merchants/${linkId}`, { method: 'DELETE' });
};
